import { render, staticRenderFns } from "./chineseProject.vue?vue&type=template&id=7d12251c&scoped=true"
import script from "./chineseProject.vue?vue&type=script&lang=js"
export * from "./chineseProject.vue?vue&type=script&lang=js"
import style0 from "./chineseProject.vue?vue&type=style&index=0&id=7d12251c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d12251c",
  null
  
)

export default component.exports